module.exports = __webpack_public_path__ + "static/media/sheet-upload.92cba122.svg";